// extracted by mini-css-extract-plugin
export var label = "_hy-2";
export var slideContainer = "_hy-0";
export var slider = "_hy-1";